import { render } from "./EmcSvg.vue?vue&type=template&id=20b4cf7d&scoped=true"
import script from "./EmcSvg.vue?vue&type=script&lang=js"
export * from "./EmcSvg.vue?vue&type=script&lang=js"

import "./EmcSvg.vue?vue&type=style&index=0&id=20b4cf7d&scoped=true&lang=css"

import exportComponent from "/Users/siorikitajima/Dropbox (Personal)/Code/GCV/ga-emc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b4cf7d"]])

export default __exports__